import {
  type ContractDtoBidUnitEnum,
  type ContractDto,
  ContractDtoBidBasisEnum,
} from '@b-stock/contract-api-client'
import { OfferingDtoOfferAmountUnitsEnum as AmountUnitsEnum } from '@b-stock/offering-api-client'

export const getRetailQuantityPrice = ({
  offerAmountUnits,
  offerAmount,
  offerQuantity,
  unitRetail,
  itemQuantity,
  contract,
  // we allow this by default, because in UI we are allowing the user to enter quantities over allocated itemQuantity, however it will be validated on submit (if overage is detected)
  allowQuantityOverflow = true,
}: {
  offerAmountUnits?: AmountUnitsEnum | ContractDtoBidUnitEnum
  offerAmount: number | null
  offerQuantity: number | null
  unitRetail: number
  itemQuantity: number
  contract?: ContractDto | null
  allowQuantityOverflow?: boolean
}) => {
  const isContract = !!contract

  const amount = offerAmount ?? 0
  const quantity =
    (isContract
      ? itemQuantity
      : !allowQuantityOverflow && offerQuantity && offerQuantity >= itemQuantity
        ? itemQuantity
        : offerQuantity) ?? 0

  let adjustedAmount = amount
  if (isContract) {
    if (contract.bidBasis === ContractDtoBidBasisEnum.Relative) {
      adjustedAmount = (amount / 100) * unitRetail
    }
  } else if (offerAmountUnits === AmountUnitsEnum.PercentMsrp) {
    adjustedAmount = (amount / 100) * unitRetail
  }

  return Number((adjustedAmount * quantity).toFixed(0)) // to ne
}
